/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
$(function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  new Swiper(".sp-swiper-btn", {
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    loop: true,
  });

  let spImgList = [
    "https://cdn.shopify.com/s/files/1/0738/0294/0723/files/202509122-p1.png",
    "https://cdn.shopify.com/s/files/1/0738/0294/0723/files/202509122-p2.png",
    "https://cdn.shopify.com/s/files/1/0738/0294/0723/files/202509122-p3.png",

    "https://cdn.shopify.com/s/files/1/0738/0294/0723/files/202509122-size-img1.png",
    "https://cdn.shopify.com/s/files/1/0738/0294/0723/files/202509122-size-img2.png",
  ];

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      let scale = document.body.clientWidth / 1080;
      $("#root").css("zoom", scale);

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              let scale = document.body.clientWidth / 1080;
              $("#root").css("zoom", scale);
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
      config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一

        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;

        let _topHeight =
          $(".time-part").height() + $(".sp-header-top").height();
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            _topHeight * $("div#root").css("zoom") -
            100 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();
  let sp_price_list = [
    {
      price1: 139.99,
      price2: 299.99,
    },
    {
      price1: 139.99,
      price2: 299.99,
    },
  ];

  let sp_price1 = 139.99;
  let sp_price2 = 299.99;

  function calcTotal(price, num) {
    let result = Number(price) * Number(num);
    return result.toFixed(2);
  }

  
  let prods = window.product
  function getCur() {
    let color = $('#sp-color div.active').attr('data-val')
    let size = $('#sp-size div.active').attr('data-val')
    return prods.filter(item => item.option1 == color && item.option2 == size)[0]
  }
  function changePrice() {
    let num = $('#calcNumber').val()
    const checkeIndex = $('.sp-check-btn .sp-check.active').index()
    if (checkeIndex == 1) { 
      num *= 2
    }
    let price = ((getCur().price * num) / 100).toFixed(2)
    let compare = ((getCur().compare_at_price * num) / 100).toFixed(2)
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    $('#sp_price1').html(price)
    $('#sp_price2').html(compare)
    
    let off_font = 100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100);
    $('.product-part .price-group .sp-row span').html(off_font)
  }

  $('.sp-btn-style').click(function () {
    const checkeIndex = $('.sp-check-btn .sp-check.active').index()
    let num = $('#calcNumber').val()
    if (checkeIndex == 1) { 
      let idArr = []
      $('.sp-select-row').each(function (index, item) { 
        let val1 = $(item).children().first().find('li.active').data('val')
        let val2 = $(item).children().eq(1).find('li.active').data('val')
        idArr.push(prods.filter(item => item.option1 == val1 && item.option2 == val2)[0])
      })
      window.location.href = '/cart/' + idArr.map(item => `${item.id}:${num}`).join(',')
    } else {
      window.location.href = '/cart/' + getCur().id + ':' + num
    }
  })


  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    changePrice()
  });
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    changePrice()
  });

  // 展示尺码弹窗
  $(".sp-size-btn").click(function () {
    $(".sp-mask").css("display", "flex");
    $(".sp-mask .size-pop").show();
    $(".sp-mask .img-pop").hide();
  });

  // 关闭弹窗按钮

  $(".sp-mask").click(function (e) {
    if ($(e.target).closest(".sp-mask .sp-btn").length > 0) {
    } else {
      $(".sp-mask").hide();
    }
  });
  // 尺码表切换事件
  $(".sp-size-wrap2 .sp-btn").click(function () {
    $(this).addClass("active").siblings().removeClass("active");
    let index = $(this).index();
    $(this)
      .parents(".sp-size-wrap2")
      .find(".sp-size-img")
      .eq(index)
      .show()
      .siblings(".sp-size-img")
      .hide();
  });

  $(function () {
    $(".option").click(function () {
      $(this).addClass("active").siblings().removeClass("active");
      // $(this);
      // style选项

      let colorOptions = $("#sp-color .option.active").index();

      let img0 = $(".product-part .sp-index1 .p-img");

      img0[0].srcset = spImgList[colorOptions];
    });

    // 购物车加购动效
    $(".cart-btn").click(function () {
      $(this).children("img").addClass("on");
      $(".sp-header-top .sp-cart .sp-num").show();
      setTimeout(function () {
        $(".cart-btn").children("img").removeClass("on");
      }, 500);
      $(".sp-header-top .sp-cart").addClass("on");
      setTimeout(function () {
        $(".sp-header-top .sp-cart").removeClass("on");
      }, 500);
    });

    // 双购物部分处理
    let spShopIndex = 0;
    $(".sp-check").click(function () {
      $(this).addClass("active").siblings().removeClass("active");
      spShopIndex = $(this).index();
      if (spShopIndex == 0) {
        $(".sp-index1").show();
        $(".sp-index2").hide();
        sp_price1 = sp_price_list[0].price1;
        sp_price2 = sp_price_list[0].price2;
      } else {
        $(".sp-index1").hide();
        $(".sp-index2").show();
        sp_price1 = sp_price_list[1].price1;
        sp_price2 = sp_price_list[1].price2;
      }
      $("#calcNumber").val(1);
      changePrice()
    });

    // 点击放大按钮
    $(".sp-large,.p-img").click(function () {
      $(".sp-mask").css("display", "flex");
      let _img;
      if (spShopIndex == 0) {
        _img = $(".product-part .sp-index1 .p-img");
        $(".sp-mask .img-pop .sp-img")[0].src = _img[0].srcset;
        $(".sp-mask .img-pop").css("height", "1200px");
      } else {
        _img = $(".product-part .sp-index2 .p-img");
        $(".sp-mask  .img-pop  .sp-img")[0].src = _img[0].srcset;
        $(".sp-mask  .img-pop  .sp-img")[1].src = _img[1].srcset;
        $(".sp-mask .img-pop").css("height", "unset");
      }
      $(".sp-mask .img-pop").css("display", "flex");
      $(".sp-mask .size-pop").hide();
    });
    let colorList = ["Khaki", "Navy Blue", "Black"];
    let modelList = ["M", "L", "XL", "2XL"];
    // 模拟select-option
    $(".sp-select").click(function () {
      $(this).siblings(".select-opt").toggle();
    });

    $(".select-opt li").click(function () {
      let spimg = $(".product-part .sp-index2 .p-img");
      let _index = $(this).index();
      let _color = $(this).attr("data-color");
      let _parent = $(this).parent().parent().siblings(".sp-select");
      if (_parent.attr("data-type") == "spColor1") {
        _parent.html(
          `<span style="background: ${_color};"></span>${colorList[_index]}`
        );
        spimg[0].srcset = spImgList[_index];
      } else if (_parent.attr("data-type") == "spColor2") {
        _parent.html(
          `<span style="background: ${_color};"></span>${colorList[_index]}`
        );
        spimg[1].srcset = spImgList[_index];
      } else {
        _parent.text(modelList[_index]);
      }
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
      $(".select-opt").hide();
    });

    let initNum = 0;
    $(".product-part .cart-btn").click(function () {
      let spNum = $(".product-part #calcNumber")[0].value;
      initNum += Number(spNum);

      // $("#calcNumber").val(1);
    //   $("#cardNum").html(initNum);
      // handleAddToCart(initNum);
      const checkeIndex = $('.sp-check-btn .sp-check.active').index()
      let idArr = []
      if (checkeIndex == 1) { 
        $('.sp-select-row').each(function (index, item) { 
          let val1 = $(item).children().first().find('li.active').data('val')
          let val2 = $(item).children().eq(1).find('li.active').data('val')
          idArr.push(prods.filter(item => item.option1 == val1 && item.option2 == val2)[0].id)
        })
      } else {
        idArr.push(getCur().id)
      }
      console.log(idArr)
      for (let i = 0; i < idArr.length; i++) {
        const id = idArr[i];
        var data = {
            id: id,
            quantity: $('#calcNumber').val(),
        }
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            success: function () {
                $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
                    $('#cardNum').html(result.item_count)
                    $('#cardNum').removeClass('sp-gray')
                })
            },
            dataType: 'json',
        })
      }

      // var img = $(".product-part .p-img");

      var img;
      if (spShopIndex == 0) {
        img = $(".product-part .sp-index1 .p-img");
      } else {
        img = $(".product-part .sp-index2 .p-img");
      }

      var flyer = img[0].cloneNode(true);
      flyer.classList.add("sp_clone");

      $(".product-part").append(flyer);
      $(".sp_clone").css({
        width: img[0].width,
        height: img[0].height,
        background: "#F1F1F3",
        position: "fixed",
        top: img[0].offsetTop,
        left: img.offset().left,
        "z-index": "99",
      });

      let finish = $(".sp-cart");
      $(".sp_clone").animate(
        {
          top: finish[0].offsetTop + $(".time-part").height(),
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        500,
        "linear",
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach();
            }
          );
        }
      );
      // 另一个
      if (spShopIndex == 1) {
        var img2;

        img2 = $(".product-part .sp-index2 .p-img2");
        var flyer2 = img2[0].cloneNode(true);
        flyer2.classList.add("sp_clone2");

        $(".product-part").append(flyer2);
        $(".sp_clone2").css({
          width: img2[0].width,
          height: img2[0].height,
          position: "fixed",
          background: "#FAF4EE",
          top: img2[0].offsetTop,
          left: img2.offset().left,
          "z-index": "99",
        });

        $(".sp_clone2").animate(
          {
            top: finish[0].offsetTop + $(".time-part").height(),
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4,
          },
          500,
          "linear",
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach();
              }
            );
          }
        );
      }
    });
  });

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }
});
